import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { SizeGuideModalComponent } from './size-guide-modal.component';
import { SizeGuideModule } from '../size-guide/size-guide.module';

@NgModule({
  imports: [CommonModule, MatDialogModule, SizeGuideModule],
  exports: [SizeGuideModalComponent],
  declarations: [SizeGuideModalComponent],
  entryComponents: [SizeGuideModalComponent]
})
export class SizeGuideModalModule {}
